import '../data/css/App.scss';

import 'bootstrap/dist/css/bootstrap.min.css';
import Speech from "./speech/Speech";
import {useGlobal} from "../contexts/GlobalContext";
import Weather from "./Weather";
import Contact from "./Contact";
import {HashRouter, Switch, Route} from "react-router-dom";
import SideNavbar from "./sidenavbar/SideNavbar";
import {useEffect} from "react";
import {createHashHistory} from 'history'
import "../data/css/App.scss"
import About from "./About/About";
import Main from "./Main";
import Github from "./github/Github";
// import showAJoke from "./speech/TellAJoke";
// import Swal from "sweetalert2";
import TellAJoke from "./speech/TellAJoke";

function App() {
    const history = createHashHistory()
    const {result, isSideBarShow, setSideBarShow, activeSite, setActiveSite, isJokeActive, setJokeActive} = useGlobal()

    const ifWasSaid = (words, href) => {
        for (const word of words) {
            if (result.includes(word)) {
                history.push(`/${href}`)
                setActiveSite(href)
                return true
            }
        }
        return false
    }

    const ifWasSaidDoJoke = (words, f) => {
        for (const word of words)
            if (result.includes(word) && isJokeActive === 0)
                setJokeActive(1)
    }

    function ifWasSaidMenu() {
        if (result.includes('menu')) setSideBarShow(!isSideBarShow)
        if (result.includes('hid') || result.includes('clos')) setSideBarShow(false)
        if (result.includes('show') || result.includes('open')) setSideBarShow(true)
    }


    const voiceAnalyse = () => {
        ifWasSaidMenu()
        ifWasSaid(["weather"], 'weather')
        ifWasSaid(['hello'], '')
        ifWasSaid(['about'], 'about')
        ifWasSaid(['git', 'hub', 'can'], 'github')
        ifWasSaid(['contact', 'email', 'linke'], 'contact')
        ifWasSaidDoJoke(['joke'])
    }


    useEffect(voiceAnalyse, [result]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {/*<div className={"intro"}></div>*/}
            {/*<div className={`${activeSite ? `${activeSite}` : "intro"}` + " container container-flex"}>*/}
            <div className={"intro" + " container container-flex m-0 p-0 w-100"}>

                <SideNavbar/>
                <div className={`${isSideBarShow ? "app-hide" : "app-show"}`}>
                    <HashRouter>
                        <Switch>
                            <Route exact path={"/"} component={Main}/>
                            <Route path={"/about"} component={About}/>
                            <Route path={"/github"} component={Github}/>
                            <Route path={"/weather"} component={Weather}/>
                            <Route path={"/contact"} component={Contact}/>
                        </Switch>
                    </HashRouter>
                </div>
                {(isJokeActive === 1) && <TellAJoke/>}
                {/*<Speech/>*/}
            </div>
        </>
    );
}

export default App;
